import { IconX } from '@tabler/icons-react';
import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { toast } from 'sonner';

const UpdateAppModal = ({ buttonComponent, callback, appData }) => {
    const [show, setShow] = useState(false);
    const [currentAppType, setCurrentAppType] = useState(appData?.appPlatform);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const update = async () => {
        loadingShow();
        let postData = {};
        if (currentAppType == 1) {
            postData = {
                "appId": appData?._id,
                "platform": appData?.appPlatform,
                "SHA256": document.getElementById('sha256').value.trim(),
                "appStatus": document.getElementById('status')?.value
            }
        }
        else if (currentAppType == 2) {
            postData = {
                "appId": appData?._id,
                "platform": currentAppType,
                "bundleId": document.getElementById('bundleId').value.trim(),
                "appStatus": document.getElementById('status')?.value
            }
        }
        else if (currentAppType == 3) {
            postData = {
                "appId": appData?._id,
                "platform": currentAppType,
                "webUrl": document.getElementById('webUrl').value?.trim(),
                "appStatus": document.getElementById('status')?.value
            }
        }
        let resp = await postApi(postData, urlApi.updateApp);
        loadingHide();
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            callback?.();
            handleClose();
        }
        else {
            toast.error(resp.message);
        }
    }

    const handleAppTypeChange = (e) => {
        setCurrentAppType(parseInt(e.target.value));
    }

    return (
        <>
            <div className='max-w-max' onClick={handleShow}>{buttonComponent}</div>
            <Modal show={show} onHide={handleClose} backdrop="static" size='lg'>
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Update {appData?.appPlatform == 1 ? "Android" : appData?.appPlatform == 2 ? "IOS" : "Web"} app.</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className='mb-3 cursor-not-allowed'>
                        <label htmlFor="platform" className='text-sm font-semibold mb-1 cursor-not-allowed'>App Platform*</label>
                        <select name="" id="platform" className='w-full px-3 py-2 rounded-md border-2 text-sm cursor-not-allowed' onChange={handleAppTypeChange} disabled defaultValue={currentAppType}>
                            <option value="" disabled>App Platform</option>
                            <option value="1">Android</option>
                            <option value="2">IOS</option>
                            <option value="3">WEB</option>
                        </select>
                    </div>
                    {currentAppType == 1 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="sha256" className='text-sm font-semibold mb-1'>Android App signature (SHA256)*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='sha256' defaultValue={appData?.appSHA256} />
                            </div>
                        </div>
                    }
                    {currentAppType == 2 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="bundleId" className='text-sm font-semibold mb-1'>IOS app Bundle ID*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='bundleId' defaultValue={appData?.appBundleId} />
                            </div>
                        </div>
                    }
                    {currentAppType == 3 &&
                        <div>
                            <div className='mb-3'>
                                <label htmlFor="webUrl" className='text-sm font-semibold mb-1'>Web URL*</label>
                                <input type="text" className="w-full px-3 py-2 rounded-md border-2 text-sm" placeholder='' id='webUrl' defaultValue={appData?.appWebUrl} />
                            </div>
                        </div>
                    }
                    <div className='mb-3'>
                        <label htmlFor="status" className='text-sm font-semibold mb-1'>Status</label>
                        <select name="" id="status" className="w-full px-3 py-2 rounded-md border-2 text-sm" defaultValue={appData?.appStatus}>
                            <option value="1">Active</option>
                            <option value="0">Inactive</option>
                            <option value="2">Delete</option>
                        </select>
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => update()}>Update</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateAppModal